import React from 'react';

const Footer = () => (
  <footer className="bg-[#0a1628] text-white py-10 md:py-16">
    <div className="container-custom px-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
        {/* Logo & Info */}
        <div className="col-span-2 md:col-span-1">
          <img 
            src="/logo.png" 
            alt="Equus Prime" 
            className="h-20 md:h-32 w-auto mb-4 md:mb-6"
          />
          <p className="text-white/60 text-sm leading-relaxed">
            La piattaforma leader in Italia per le aste di cavalli online. Qualità, sicurezza e trasparenza.
          </p>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-display text-lg mb-4 text-[#c9a227]">Navigazione</h4>
          <ul className="space-y-2">
            <li><a href="/aste" className="footer-link">Aste</a></li>
            <li><a href="/attualita" className="footer-link">Attualit&agrave;</a></li>
            <li><a href="/risultati" className="footer-link">Risultati</a></li>
            <li><a href="/come-vendere" className="footer-link">Come Vendere</a></li>
            <li><a href="/aste-partner" className="footer-link">Aste per Partner</a></li>
            <li><a href="/chi-siamo" className="footer-link">Informazioni su Equus Prime</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="font-display text-lg mb-4 text-[#c9a227]">Legale</h4>
          <ul className="space-y-2">
            <li><a href="/termini-asta" className="footer-link">Termini dell'Asta</a></li>
            <li><a href="/termini" className="footer-link">Termini e Condizioni</a></li>
            <li><a href="/privacy" className="footer-link">Privacy Policy</a></li>
            <li><a href="/cookie" className="footer-link">Cookie Policy</a></li>
            <li><a href="/risultati" className="footer-link">Risultati Aste</a></li>
            <li><a href="/completate" className="footer-link">Aste Completate</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-display text-lg mb-4 text-[#c9a227]">Contatti</h4>
          <ul className="space-y-2 text-white/60">
            <li>Blinkers Srl</li>
            <li>P.IVA: 11115801216</li>
            <li>Via Isonzo 36</li>
            <li>80034 Marigliano (NA)</li>
            <li><a href="mailto:info@equusprime.it" className="text-[#c9a227]">info@equusprime.it</a></li>
            <li className="pt-2"><a href="/assistenza" className="footer-link">Assistenza Clienti</a></li>
          </ul>
        </div>
      </div>

      <hr className="border-white/10 my-8" />

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white/40 text-sm">
          &copy; {new Date().getFullYear()} Equus Prime - Blinkers Srl. Tutti i diritti riservati.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
